var r = Object.defineProperty;
var d = (s, t, e) => t in s ? r(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e;
var o = (s, t, e) => d(s, typeof t != "symbol" ? t + "" : t, e);
import { HttpClient as c, httpClient as n } from "../../httpClient.js";
class u extends c {
  constructor() {
    super(...arguments);
    o(this, "endpoint", "/discussions");
  }
  async getAll(e) {
    return n.get(this.endpoint, { params: { courseId: e } });
  }
  async create(e) {
    return n.post(this.endpoint, e);
  }
  async update(e) {
    const { id: i, ...p } = e;
    return n.put(`${this.endpoint}/${i}`, p);
  }
  async remove(e) {
    return n.delete(`${this.endpoint}/${e}`);
  }
  async createReply(e) {
    return n.post(
      `${this.endpoint}/${e.discussionId}/replies`,
      e
    );
  }
  async updateReply(e) {
    const { id: i, ...p } = e;
    return n.put(`${this.endpoint}/replies/${i}`, p);
  }
  async removeReply(e) {
    return n.delete(`${this.endpoint}/replies/${e}`);
  }
}
const y = new u();
export {
  y as default
};
